export const Carroceria = [
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.trasera",
        "PointID": 18,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.maletero",
        "PointID": 17,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.rtraseraIzq",
        "PointID": 15,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.rTraseraDch",
        "PointID": 14,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.aletaTrasIzq",
        "PointID": 20,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.aletaTrasDch",
        "PointID": 19,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.lunaTrasera",
        "PointID": 16,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.puertaTrasIzq",
        "PointID": 12,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.puertatrasDer",
        "PointID": 11,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.faldonIzq",
        "PointID": 10,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.faldonDer",
        "PointID": 9,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.puertaDelIzq",
        "PointID": 8,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.puertaDelDer",
        "PointID": 7,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.techo",
        "PointID": 13,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.ruedaDelIzq",
        "PointID": 3,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.ruedaDelDer",
        "PointID": 2,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.lunaDelantera",
        "PointID": 6,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.capo",
        "PointID": 1,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.frontal",
        "PointID": 0,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.aletaDelIzq",
        "PointID": 5,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    },
    {
        "ID": 0,
        "PointDescription": "gestion_vehiculos_vc.aletaDelDer",
        "PointID": 4,
        "PointState": 0,
        "PointStateDescription": "labels.correcto",
        "VehicleValuationID": 0
    }
];
